<template>
    <div class="row">
        <!-- MODAL -->
        <b-modal id="addCompanyModal">
            <template #modal-header>
                Add School to Checkout List
            </template>
            <b-input-group prepend="Id"><b-input type="text" disabled readonly :value="company.id"></b-input></b-input-group>
            <b-input-group prepend="Name"><b-input type="text" :value="company.name" v-model="customCompanyName"></b-input></b-input-group>
            <template #modal-footer="{close}">
                <b-btn @click="close()" variant="secondary">Close</b-btn>
                <b-btn @click="addSchoolToList()" variant="primary">Add</b-btn>
            </template>
        </b-modal>
        <b-modal id="deleteConfirmationModal">
            <template #modal-header>Delete Charter From List?</template>
            <template #modal-footer="{close}">
                <b-btn @click="close()" variant="secondary">Close</b-btn>
                <b-btn @click="removeSchool(company.id)" variant="danger">Remove</b-btn>
            </template>
        </b-modal>

        <div class="col-4">
            <div>
                <h3 class="d-inline border-bottom">Charter Orgs</h3>
                <span class="popover-info" v-b-popover.hover.bottom="'The organizations in this list will appear on the checkout page as charter options.'">
                    <font-awesome-icon :icon="['fas', 'info-circle']"></font-awesome-icon>
                </span>
            </div>
            <div v-if="chartersByName.length" class="charter-list">
                <div v-for="(school, i) in chartersByName" :key="`charter_${i}`">
                    <small v-b-popover.hover.top="`ID: ${school.company_id}`">{{school.company_name}}</small>
                </div>
            </div>
        </div>
        <div class="col-8">
            <h3 class="border-bottom">Search Organizations</h3>
            <!-- Search input -->
            <b-input-group prepend="Search">
                <b-select :options="states" v-model="selectedState"></b-select>
                <b-input type="text" v-model="search" @input="searchInput" placeholder="Name..."></b-input>
            </b-input-group>

            <div class="mt-3">
                <div v-if="searchResultCompanies.length">
                    <b-pagination
                        v-model="config.page"
                        :total-rows="config.totalRows"
                        :per-page="config.perPage"
                        aria-controls="my-table"
                    ></b-pagination>
                    <b-table
                        small
                        id="my-table"
                        :fields="config.fields"
                        :items="searchResultCompanies"
                        :per-page="config.perPage"
                        :current-page="config.page"
                    >
                        <template #cell(name)="data">
                            <span v-b-popover.hover.top="data.item.parents">{{data.item.name}}</span>
                        </template>
                        <template #cell(actions)="data">
                            <b-btn v-if="isInList(data.item.id)" variant="danger" @click="showRemoveModal(data.item)">
                                <font-awesome-icon :icon="['fas','trash']"></font-awesome-icon>
                            </b-btn>
                            <b-btn v-else variant="primary" @click="showAddModal(data.item)">
                                <font-awesome-icon :icon="['fas','plus']"></font-awesome-icon>
                            </b-btn>
                        </template>
                    </b-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {optionStates} from "@/common/states";

export default {
    name: "CharterSchools",
    computed: {
        chartersById() {
            return this.charterSchools.map((item) => item.company_id);
        },
        chartersByName() {
            return this.charterSchools.sort((a, b) => a.company_name.localeCompare(b.company_name));
        }
    },
    data:() => ({
        search: null,
        states: optionStates,
        selectedState: null,
        searchResultCompanies: [],
        charterSchools: [],
        company: {company_id: null, name: null,},
        customCompanyName: "",
        config: {
            page: 1,
            perPage: 8,
            totalRows: null,
            fields: [
                {key: 'id', label: 'company id'},
                'name', 'city', 'state','zip', 'actions'
            ]
        }
    }),
    methods: {
        address(company) {
            return `${company.address}  (${company.zip})`;
        },
        searchInput: _.debounce(function() {
            if (!this.search || this.search === '' || this.search.length < 4)
                return;
            this.searchSchools();
        }, 800),
        searchSchools() {
            this.$store.dispatch('searchSchools', {search: this.search, state: this.selectedState})
                .then((response) => {
                    if (!response)
                        return;

                    if (response.success == 0)
                        return;

                    this.setResults(response.data);

                    //"20525": {
                    //     "id": "20525",
                    //     "name": "Alpine School District (American Fork)",
                    //     "points": 0,
                    //     "address": "575 N 100 E",
                    //     "city": "American Fork",
                    //     "state": "UT",
                    //     "zip": "84003"
                    // },
                });
        },
        setResults(result) {
            let arr = Object.values(result);
            console.log(arr);
            this.searchResultCompanies = arr;
            this.config.totalRows = this.searchResultCompanies.length;
        },
        getCharterSchools() {
            this.$store.dispatch('getCharterSchools').then((result) => {
                this.charterSchools = result.data;
                // this.$nextTick(() => {console.log(this.chartersById)});
            });
        },
        isInList(id) {
            if (typeof id == 'string')
                id = parseInt(id);

            return this.chartersById.includes(id);
        },
        addSchoolToList() {
            this.$store.dispatch('addCharterSchool', {id: this.company.id, name: this.customCompanyName})
                .then(() => {
                    this.$swal({
                        toast: true,
                        html: 'Saved',
                        type: 'success',
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    });
                    this.getCharterSchools();
                });
            this.$bvModal.hide('addCompanyModal');
        },
        showAddModal(company) {
            this.company = company;
            this.customCompanyName = company.name;
            this.$bvModal.show('addCompanyModal');
        },
        showRemoveModal(company) {
            this.company = company;
            this.$bvModal.show('deleteConfirmationModal');
        },
        removeSchool(id) {
            this.$store.dispatch('removeCharterSchool', id)
            .then((result) => {
                this.getCharterSchools();
            });
            this.$bvModal.hide('deleteConfirmationModal');
        }

    },

    created() {
        this.getCharterSchools();
        console.log(this.states);
    }
}
</script>

<style scoped>
.charter-list {
    padding-top: 5px;
    font-size: 18px;
    height: 70vh;
    overflow-y: scroll;
}
.popover-info {
    color: green;
    margin: -10px 5px 5px;
}
</style>